import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
} from "../../actions";
import axios from "../../axios";
import { BankingInfoComponent } from "./components/BankingInfoComponent";

class BankingInfo extends Component {
  state = {
    currentRecord: null,
  };

  componentDidMount() {
    this.getOptionsData();
  }

  async getOptionsData() {
    const { handleAppError, setLoading } = this.props;
    try {
      setLoading(true);
      const response = await axios.get("/options/banking-info");
      const rawOptions = response.data.data;
      
      const bankAccountRaw = rawOptions.find(o => o.key === 'bank_accounts');
      const bankAccount = bankAccountRaw ? JSON.parse(bankAccountRaw.value)[0] : {name: '', iban: '', bank: ''};

      const options = {};
      options.bankaccountname = bankAccount.name;
      options.iban = bankAccount.iban;
      options.bankname = bankAccount.bank;
      options.bankcardnumber = rawOptions.find(o => o.key === 'bankcardnumber')?.value || '';
      options.bankcardholdername = rawOptions.find(o => o.key === 'bankcardholdername')?.value || '';
      options.bankcardexpirydate = rawOptions.find(o => o.key === 'bankcardexpirydate')?.value || '';
      options.bankcardcvv = rawOptions.find(o => o.key === 'bankcardcvv')?.value || '';
      await this.setState({
        currentRecord: options,
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }

  async submit(optionsRecord) {
    const { setLoading, handleAppError, showMessage } = this.props;
    const { lang } = this.props.user;
    try {
      setLoading(true);
      const optionsRecordToPost = {
        bank_accounts: [
          {
            name: optionsRecord.bankaccountname,
            iban: optionsRecord.iban,
            bank: optionsRecord.bankname,
          },
        ],
        bankcardnumber: optionsRecord.bankcardnumber,
        bankcardholdername: optionsRecord.bankcardholdername,
        bankcardexpirydate: optionsRecord.bankcardexpirydate,
        bankcardcvv: optionsRecord.bankcardcvv,
      };
      await axios.post("options/banking-info/update", {
        options: JSON.stringify(optionsRecordToPost),
      });
      showMessage({
        type: "success",
        title: window.sys_app_translate("Operation Succeeded", lang),
        message: window.sys_app_translate(
          "Options successfully updated!",
          lang
        ),
      });
      setLoading(false);
    } catch (error) {
      handleAppError(error);
    }
  }

  render() {
    const { lang, permissions, is_super_admin } = this.props.user;
    const { showMessage, handleAppError, setLoading } = this.props;
    const { currentRecord } = this.state;
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{window.sys_app_translate("Banking Info", lang)}</title>
        </Helmet>
        {currentRecord && (
          <BankingInfoComponent
            permissions={permissions}
            is_super_admin={is_super_admin}
            optionsRecord={currentRecord}
            submitRecord={this.submit.bind(this)}
            showMessage={showMessage}
            handleAppError={handleAppError}
            setLoading={setLoading}
          />
        )}
      </>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { user } = authUser;
  const { formErrors, currentRecord } = appReducer;
  return { user, formErrors, currentRecord };
};
export default connect(mapStateToProps, {
  setLoading,
  showMessage,
  handleAppError,
  clearFormErrors,
  setCurrentRecord,
})(BankingInfo);
